// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetArticleByIdRequestModel from '../../model/get-article-by-id-request-model';
import GetArticleByIdRequestDTO from '../dto/get-article-by-id-request-dto';
import dtoSchema from '../schemas/get-article-by-id-request-schema';

export default abstract class GetArticleByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetArticleByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetArticleByIdRequestDTO>): GetArticleByIdRequestModel;
  static toModel(dto: DeepPartial<GetArticleByIdRequestDTO> | undefined | null): GetArticleByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetArticleByIdRequestDTO> | undefined | null): GetArticleByIdRequestModel | undefined {
    return dto ? new GetArticleByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetArticleByIdRequestModel> | GetArticleByIdRequestModel): GetArticleByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetArticleByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetArticleByIdRequestModel, can not map to GetArticleByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
